'use strict';

import { getAjaxUrlWithParams } from '@jspartials/filter-utils';
import { gtmLaunchApplyFilter } from '@jspartials/gtm-utils';

// Selectors
const selector = {
  multiselect: '.js-multiselect'
};

// Variables
const customEventNameForAjaxRequestToSearch = 'sendAjaxRequestToSearch';

// Functions

/**
 * Init all the multi selects on page
 */
const initMultiSelects = () => {
  const allMultiSelects = document.querySelectorAll(selector.multiselect) || [];

  if (allMultiSelects.length > 0) {
    allMultiSelects.forEach((multiSelectElement) => {
      initMultiSelect(multiSelectElement);
    });
  }
};

/**
 * Init the multi select
 * @param {HTMLElement} elem HTML element to init the multi select
 * @returns {void}
 */
const initMultiSelect = (element) => {
  const filterId = element.getAttribute('id');
  const id = `#${filterId}`;
  const msgNoResults =
    element?.dataset?.multiselectMsgNoResults || 'not results found';
  const msgPlaceholder =
    element?.dataset?.multiselectMsgPlaceholder || 'search or select';
  const multiSelect = new IconicMultiSelect({
    select: id,
    noResults: msgNoResults,
    placeholder: msgPlaceholder
  });

  multiSelect.init();
  multiSelect.subscribe(function (event) {
    manageMultiSelectEvents(event, filterId);
  });

  const iconicMultiselect = element.nextElementSibling;
  if (iconicMultiselect) {
    const svgIconClear =
      iconicMultiselect.querySelector('.multiselect__clear-btn svg') || null;
    if (svgIconClear) {
      svgIconClear.setAttribute('role', 'img');
      svgIconClear.setAttribute('aria-label', 'Clear selection');
    }
  }
};

/**
 * Manage the multi select events
 * @param {Object} event Event launched
 * @param {String} filterId Filter id
 * @returns {void}
 */
const manageMultiSelectEvents = (event, filterId) => {
  const selectedOption = document.querySelector(
    `${selector.multiselect} option[value="${event.value}"]`
  );
  const ajaxUrl = getAjaxUrlWithParams(selectedOption.dataset.params);
  const filterValue = selectedOption?.dataset?.presentationId;

  if (event.action === 'ADD_OPTION') {
    gtmLaunchApplyFilter(filterId, filterValue);
  }

  document.dispatchEvent(
    new CustomEvent(customEventNameForAjaxRequestToSearch, {
      detail: {
        url: ajaxUrl
      }
    })
  );
};

export { initMultiSelects };
